export enum EnumTipoFatura {
    Cliente = 0,
    Revenda = 1,
    Licença = 2,
}